export type Tone = 'ok' | 'warn' | 'error' | 'info' | 'test' | 'neutral';

export type Vote = 'approved' | 'suggestions' | 'waiting' | 'rejected' | 'none';

export type Env = 'P' | 'A' | 'T' | 'L';

/** Fixed avatar background per user, white initials on top. */
export const AVATAR_PALETTE = ['#3851c4', '#a61b1b', '#8a5300', '#7a2e9a', '#0e7490', '#2f6f4f', '#b4531a', '#9d2468'];

export function avatarColor(seed: number | string | null | undefined): string {
    if (seed === null || seed === undefined || seed === '') {
        return '#9aa0a6';
    }
    let n = Number(seed);
    if (!Number.isFinite(n)) {
        n = [...String(seed)].reduce((sum, char) => sum + char.charCodeAt(0), 0);
    }
    return AVATAR_PALETTE[Math.abs(Math.trunc(n)) % AVATAR_PALETTE.length];
}

export function initials(name: string | null | undefined): string {
    // Azure groups ("[CRM26]\Project Administrators") by the group name, without the project
    const parts = (name ?? '').replace(/^\[[^\]]*\]\\/, '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) {
        return '?';
    }
    if (parts.length === 1) {
        return parts[0].substring(0, 2).toUpperCase();
    }
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export const VOTE_COLORS: Record<Vote, string> = {
    approved: '#1e8e5a',
    suggestions: '#7cc9a0',
    waiting: '#e0a100',
    rejected: '#d93025',
    none: '#c9ccd1',
};

export const VOTE_LABELS: Record<Vote, string> = {
    approved: 'Goedgekeurd',
    suggestions: 'Goedgekeurd met suggesties',
    waiting: 'Wacht op auteur',
    rejected: 'Afgewezen',
    none: 'Nog niet gestemd',
};

/** Azure DevOps reviewer vote (10, 5, 0, -5, -10) to the vote colors of the design. */
export function voteFromAzure(vote: number | null | undefined): Vote {
    switch (vote) {
        case 10:
            return 'approved';
        case 5:
            return 'suggestions';
        case -5:
            return 'waiting';
        case -10:
            return 'rejected';
        default:
            return 'none';
    }
}
